import { ReactNode } from 'react';

/**
 * Props for the SignupSteps wrapper.
 */
interface SignupStepsProps {
  /** SignupStep children rendered as a vertical stack. */
  children: ReactNode;
}

/**
 * Vertical stack wrapper for the four signup step cards.
 * Provides consistent spacing between cards.
 */
export function SignupSteps({ children }: SignupStepsProps) {
  return <div className="flex flex-col gap-4">{children}</div>;
}
